export interface BodyDailyReport {
  sucursal: string;
  fechaInicio: string;
  fechaFin: string;
}

export interface ResponseDailyReport {
  Mes:             string;
  Día:             string;
  Fecha:           string;
  Total:           number | string;
  Acceso:          string;
  "Tipo Vehículo": VehicleType;
}

export enum VehicleType {
  Carro = "Carro",
  Moto = "Moto",
}
